import { Spacing } from '../../utils/styles';
import { Table } from './Table';

const SELECT_COLUMN_WIDTH = 48 - Spacing.LARGE;
const DEFAULT_COLUMN_WIDTH = 'minmax(0, 1fr)';

export function computeGridTemplateColumnsStyle<Item>(
  columns: Array<Table.ColumnDescriptor<Item>>,
  selectable: boolean
): Partial<CSSStyleDeclaration> {
  const template = columns.map((x) => x.width ?? DEFAULT_COLUMN_WIDTH).join(' ');

  return {
    gridTemplateColumns: selectable ? `${SELECT_COLUMN_WIDTH}px ${template}` : template
  };
}
